<template>
    <div>
        <div class="back" v-if="isVisible" @click="hideModal"></div>
        <div class="serviceView" v-if="isVisible">
            <div class="modalView_pop">
                <div class="modalView_pop_l">
                    <img class="modalView_pop_l_polygon_1" src="@/assets/images/polygon_1.png"/>
                    <img class="modalView_pop_l_polygon_2" src="@/assets/images/polygon_2.png"/>
                    <div class="modalView_pop_l_view">
                        <div class="modalView_pop_l_view_t">
                            <div class="modalView_pop_l_view_t_1">
                                <div class="modalView_pop_l_view_t_3_text">{{ $t('serviceI18n.title') }}</div>
                            </div>
                            <div class="modalView_pop_l_view_t_2">{{ $t('serviceI18n.desc') }}</div>
                        </div>
                        <div class="modalView_pop_l_view_b">
                            <div class="modalView_pop_l_view_b_2">
                                <div class="modalView_pop_r_2_choose">
                                    <div class="modalView_pop_r_2_choose_v"
                                        @click="chooseProduct(item)"
                                        v-for="item in productList"
                                        :key="item.code"
                                    >
                                        <input
                                            class="modalView_pop_r_2_choose_v_input"
                                            type="radio"
                                            name="product"
                                            :value="item.code"
                                            v-model="selectProduct"
                                        >
                                        <span>{{ item.name }}</span>
                                    </div>
                                </div>
                            </div>
                            <div class="modalView_pop_l_view_b_table">
                                <el-table
                                    :data="tableData"
                                    height="100%"
                                    border
                                    v-loading="loading"
                                    ref="serviceTable"
                                    style="width: 100%"
                                    :row-style="rowStyle"
                                >
                                    <el-table-column
                                        prop="id"
                                        :label="$t('serviceI18n.service_id')"
                                        align="center"
                                        class-name="wrap-header"
                                    >
                                    </el-table-column>
                                    <el-table-column
                                        prop="reseller_name"
                                        :label="$t('serviceI18n.channel')"
                                        align="center"
                                        :class-name="getHeaderClass($t('serviceI18n.channel'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ scope.row.license_code?.reseller?.reseller_name || '中碳' }}
                                        </template>
                                    </el-table-column>
                                    <!-- <el-table-column
                                        prop="reseller_order_id"
                                        :label="$t('serviceI18n.channelOrderId')"
                                        align="center"
                                        :class-name="getHeaderClass($t('serviceI18n.channelOrderId'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ scope.row.license_code?.reseller_order_id || '' }}
                                        </template>
                                    </el-table-column> -->
                                    <el-table-column
                                        prop="permission_type"
                                        :label="$t('serviceI18n.permission_type')"
                                        align="center"
                                        :class-name="getHeaderClass($t('serviceI18n.permission_type'))"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="scope.row.order">{{ $t('serviceI18n.formal_service') }}</span>
                                            <span v-else-if="scope.row.license_code">{{ scope.row.license_code?.service_package?.package_spec || '' }}</span>
                                            <span v-else>{{ $t('serviceI18n.experience_service') }}</span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="feature_code"
                                        :label="$t('serviceI18n.feature_code')"
                                        align="center"
                                        :class-name="getHeaderClass($t('serviceI18n.feature_code'))"
                                    >
                                        <template slot-scope="scope">
                                            <div v-if="scope.row.feature_code == 'tpc'">{{ $t('serviceI18n.tpc') }}</div>
                                            <div v-else-if="scope.row.feature_code == 'tzj'">{{ $t('serviceI18n.tzj') }}</div>
                                            <div v-else>{{ $t('serviceI18n.esg') }}</div>
                                        </template>
                                    </el-table-column>

                                    <!-- 动态表头 -->
                                    <el-table-column
                                        v-for="col in dynamicColumns[selectProduct]"
                                        :key="col.prop"
                                        :prop="col.prop"
                                        :label="$t(col.label)"
                                        align="center"
                                        :class-name="getHeaderClass($t(col.label))"
                                    >
                                        <template slot-scope="scope">
                                            <span v-if="col.renderKey">
                                                {{ $t(col.renderKey(scope.row)) }}
                                            </span>
                                            <span v-else>
                                                {{ col.render(scope.row) }}
                                            </span>
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="remaining_count"
                                        :label="$t('serviceI18n.remaining_count')"
                                        align="center"
                                        width="90"
                                        :class-name="getHeaderClass($t('serviceI18n.remaining_count'))"
                                    >
                                        <template slot-scope="scope">
                                            {{ getPermissionStatus(scope.row) }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column
                                        prop="expire_at"
                                        :label="$t('serviceI18n.expired_time')"
                                        align="center"
                                        :class-name="getHeaderClass($t('serviceI18n.expired_time'))"
                                    />
                                    <el-table-column
                                        :label="$t('serviceI18n.action')"
                                        align="center"
                                        :class-name="getHeaderClass($t('serviceI18n.action'))"
                                        width="100"
                                    >
                                        <template slot-scope="scope">
                                            <div v-if="scope.row.permission_type == 'PAID' && scope.row.order && scope.row.feature_code == 'tpc'">
                                                <el-button @click="handleRowClick(scope.row)" type="text" size="small">{{ $t('serviceI18n.add_service') }}</el-button>
                                            </div>
                                            <div v-else-if="scope.row.permission_type == 'EXPIRED' && scope.row.order">
                                                <el-button @click="dialogVisible = true" type="text" size="small">联系我们</el-button>
                                            </div>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                            <!-- <div class="modalView_pop_l_view_b_page">
                                <el-pagination
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="currentPage"
                                    :page-size="100"
                                    layout="prev, pager, next"
                                    :total="totalNum">
                                </el-pagination>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="modalView_pop_r">
                    <!-- 套餐加购服务 -->
                    <div class="modalView_pop_r_2" v-if="productInfo && currentRowId">
                        <div class="modalView_pop_r_2_title">
                            <span class="modalView_pop_r_2_title_1 active">{{ $t('serviceI18n.add_service_tips') }}</span>
                        </div>
                        <div class="modalView_pop_r_2_info">
                            <div class="modalView_pop_r_2_info_title">
                                {{ productInfo?.feature_code == 'tpc' ? $t('serviceI18n.tpc') : productInfo?.feature_code == 'tzj' ? $t('serviceI18n.tzj') : productInfo?.feature_code == 'esg' ? $t('serviceI18n.esg') : '' }}
                            </div>
                            <div class="modalView_pop_r_2_info_view borderBottom">
                                <div class="modalView_pop_r_2_info_view_1">{{ $t('serviceI18n.category') }}</div>
                                <div class="modalView_pop_r_2_info_view_2">{{ $t('serviceI18n.original_service') }}</div>
                                <div class="modalView_pop_r_2_info_view_2">{{ $t('serviceI18n.changed_to') }}</div>
                            </div>
                            <div class="modalView_pop_r_2_info_view">
                                <div class="modalView_pop_r_2_info_view_1">{{ $t('serviceI18n.scope') }}</div>
                                <div class="modalView_pop_r_2_info_view_2">{{ productInfo ? productInfo.config.scope == 0 ? $t('serviceI18n.scope_list[0].name') : $t('serviceI18n.scope_list[1].name') : "" }}</div>
                                <el-select v-model="scopeValue" placeholder="请选择" @change="chooseF">
                                    <el-option
                                        v-for="item in scopeList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        class="modalView_pop_r_2_info_view_2"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                            <div class="modalView_pop_r_2_info_view">
                                <div class="modalView_pop_r_2_info_view_1">{{ $t('serviceI18n.address_limit') }}</div>
                                <div class="modalView_pop_r_2_info_view_2">{{ productInfo ? productInfo.config.address_limit : ""}}</div>
                                <div class="modalView_pop_r_2_info_view_input">
                                    <el-input
                                        onKeypress="return (/[\d]/.test(String.fromCharCode(event.keyCode)))"
                                        class="modalView_pop_r_2_info_view_input_view"
                                        v-model="companyValue"
                                        @blur="chooseC"
                                    ></el-input>
                                </div>
                            </div>
                            <div class="modalView_pop_r_2_info_view borderBottom">
                                <div class="modalView_pop_r_2_info_view_1">{{ $t('serviceI18n.source_limit') }}</div>
                                <div class="modalView_pop_r_2_info_view_2">{{ productInfo ? productInfo.config.source_limit == 0 ? '≤100' : productInfo.config.source_limit == 1 ? '101-500' : productInfo.config.source_limit == 2 ? '＞500' : '' : "" }}</div>
                                <el-select v-model="emissionSourceValue" placeholder="请选择" @change="chooseE">
                                    <el-option
                                        v-for="item in emissionSourceList"
                                        :key="item.value"
                                        :label="item.label"
                                        :value="item.value"
                                        class="modalView_pop_r_2_info_view_2"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="modalView_pop_r_2_total">
                            <div class="modalView_pop_r_2_total_l">{{ $t('serviceI18n.add_service_total') }}：</div>
                            <div class="modalView_pop_r_2_total_r">
                                <label class="modalView_pop_r_2_total_l">￥</label>
                                <label>{{ addTotal }}</label>
                            </div>
                        </div>
                        <div class="pay" :class="{ activePay: isPay == true }">
                            <el-button :disabled="!isPay" class="pay_inner" @click="confirm">{{ $t('serviceI18n.confirm') }}</el-button>
                        </div>
                    </div>
                    <!-- 正式版套餐服务 -->
                     <div class="modalView_pop_r_2" v-else>
                        
                        <div class="modalView_pop_r_2_title">
                            <span
                                class="modalView_pop_r_2_title_1 active"
                            >
                                {{ $t(titleConfig[selectProduct]?.[type]?.main) || '套餐服务' }}
                            </span>

                            <!-- selectProduct != '碳足迹'为暂时判断，碳足迹当前不存在购买，后期去除此判断 -->
                            <span
                                v-if="!loading && tableData.length == 0"
                                class="modalView_pop_r_2_title_1"
                                @click="changeType"
                            >
                                {{ $t(titleConfig[selectProduct]?.[type]?.switch) || '' }}
                            </span>
                            
                        </div>
                        <div class="modalView_pop_r_2_info autoY">
                            <div class="modalView_pop_r_2_info_msView">
                                <template v-if="productContent[selectProduct] && productContent[selectProduct][type]">
                                    <div
                                        class="modalView_pop_r_2_info_ms"
                                        v-for="(item, idx) in productContent[selectProduct][type]"
                                        :key="idx"
                                    >
                                    <span v-html="highlightText(item.key, item.highlight)"></span>
                                        <!-- <span class="highlight">{{ $t(item.highlight) }}</span>&nbsp;&nbsp;&nbsp;{{ $t(item.key).replace(item.highlight, '') }} -->
                                    </div>
                                </template>
                                <el-button v-if="type == 'formal'" class="pay" @click="goPay">{{ $t('serviceI18n.buy') }}</el-button>
                                <el-button v-else :disabled="applyTryLoading" class="pay" @click="applyTry">{{ $t('serviceI18n.apply_try') }}</el-button>
                            </div>
                        </div>
                     </div>
                </div>
            </div>
        </div>
        <ChooseProduct ref="chooseProduct"/>
        <el-dialog
            title="提示"
            :visible.sync="dialogVisible"
            width="30%">
            <span>该套餐服务已过期，请联系我们<br>邮箱：customerservice@carbonneutrality-group.com</span>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getPermissions, getFeatures, trial } from "@/api/index";
import ChooseProduct from './ChooseProduct';
import { mapState, mapMutations } from "vuex";
import serviceDialogConfig from '@/utils/config';
export default {
  components: {
    ChooseProduct
  },
  data() {
    return {
        isVisible: false, // 控制弹窗的显示状态
        noShow: true, //一期隐藏加购套餐
        rawProductList:[],
        selectProduct:"", //选择的产品title
        selectProductId:"", // 选择的产品feature_id
        currentRowId: null, // 当前点击的行ID
        productInfo:null,
        tableData: [],
        totalNum:0,
        currentPage: 1,
        scopeValue: '',
        companyValue: '',
        emissionSourceValue: '',
        // scopeList: [{
        //   value: 0,
        //   label: this.$t('serviceI18n.scope_list[0].name')
        // }, {
        //   value: 1,
        //   label: this.$t('serviceI18n.scope_list[1].name')
        // }],
        emissionSourceList: [{
            value: 0,
            label: '≤100'
        }, {
            value: 1,
            label: '101-500'
        }, {
            value: 2,
            label: '＞500'
        }],
        isPay: false,
        addTotal: 0,
        basePrice: 9800,
        type: "formal",
        applyTryLoading: true,
        loading: true,
        ...serviceDialogConfig,
        dialogVisible: false,
    }
  },
  methods: {
    ...mapMutations(["setOrderInfo"]),

    getHeaderClass(label) {
      // 判断内容是否包含英文
      const hasEnglish = /[a-zA-Z]/.test(label);
      return hasEnglish ? 'no-wrap-header' : 'wrap-header';
    },

    //功能权限列表
    async fetchSidebarList() {
      try {
        const res = await getFeatures();
        if (res.data && Array.isArray(res.data.data)) {
            console.log(res.data.data,'res.data.data,res.data.data')
            this.rawProductList = res.data.data.map(item => ({
                ...item,
            }));
            if(this.rawProductList.length > 0){
                this.selectProduct = this.rawProductList[0].code;
                this.selectProductId = this.rawProductList[0].id;
                console.log(this.selectProduct,'res.data.data,res.data.data')
            }
        }
      } catch (e) {
        this.$message.error(this.$t('serviceI18n.get_product_list_failed'));
      }
    },

     highlightText(key, highlight) {
      const text = this.$t(key); // 获取完整翻译文本
      const regex = new RegExp(`(${highlight})`, 'g'); // 匹配高亮词
      return text.replace(regex, `<span class="highlight">${highlight}</span>`);
    },

    // 显示弹窗
    async showModal() {
        this.isVisible = true; // 假设 isVisible 控制弹窗的显示状态
        await this.fetchSidebarList();
        this.loadList();
        // document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },

    // 隐藏弹窗
    hideModal() {
        this.isVisible = false; // 假设 isVisible 控制弹窗的显示状态
        document.body.style.overflow = ''; // 恢复页面滚动
        this.currentRowId = null; // 清空当前选中行的 ID
        this.productInfo = null; // 清空选中的产品信息
        this.type = "formal"
        if(this.rawProductList.length > 0){
            this.selectProduct = this.rawProductList[0].code;
        }
    },

    // 许可列表
    async loadList() {
        this.loading = true
        getPermissions({
            page: this.currentPage,
            limit: 100,
            feature_id: this.selectProductId
        }).then((res) => {
            if (res.data.code === 200) {
                this.loading = false
                const list = res.data.data.items;
                this.tableData = list
                this.$nextTick(() => {
                    if (this.$refs.serviceTable && this.$refs.serviceTable.doLayout) {
                        this.$refs.serviceTable.doLayout();
                    }
                });
            } else {
                this.loading = false
                this.$message.error(res.data.msg || this.$t('serviceI18n.get_product_list_failed'));
                this.hideModal()
            }
        }).catch((error) => {
            this.loading = false
            this.hideModal()
            this.$message.error(error || this.$t('serviceI18n.get_product_list_failed'));
        });
    },

    // 当前页处理
    handleCurrentChange(val) {
        this.currentPage = val;
        this.loadList()
    },

    // 选择范围
    chooseF() {
        this.totalPrice()
        // this.checkPay()
    },

    // 选择排放源
    chooseE() {
        this.totalPrice()
        // this.checkPay()
    },

    // 选择公司数量
    chooseC() {
        if(this.companyValue && Number(this.companyValue) <= Number(this.productInfo.address_limit)){
            return
        }
        this.companyValue = this.companyValue.trim();
        // 正则表达式校验：正整数（不含0、e和符号）
        const regex = /^[1-9]\d*$/;
        if (!regex.test(this.companyValue)) {
            if (this.companyValue.startsWith('0') && this.companyValue.length > 1) {
                this.companyValue = this.companyValue.slice(1); // 移除开头的0
            }
        }
        if(this.companyValue > 1000){
            this.companyValue = 1000;
        }
        this.totalPrice()
    },

    //匹配featureId
    async searchFeatureId() {
        const res = await getFeatures();
        if (res.status === 200) {
            const feature = res.data.data.find(item => item.code === this.selectProduct);
            if (feature) {
                return feature.id; // 返回 feature.id
            } else {
                this.$message({
                    message: this.$t('serviceI18n.get_feature_id_failed'),
                    type: 'error'
                });
                throw new Error(this.$t('serviceI18n.get_feature_id_failed'));
            }
        } else {
        this.$message({
            message: res.data.msg,
            type: 'error'
        });
        throw new Error(res.data.msg);
        }
    },

    //加购提交
    async confirm(){
        const addProduct = {
            config: {
                scope: this.scopeValue,
                source_limit: this.emissionSourceValue,
                address_limit: Number(this.companyValue),
                amount: this.addTotal,
                old_order_id: this.productInfo.order.id,
                featureName: this.selectProduct
            }
        }
        this.hideModal()
        this.$refs.chooseProduct.showModal(addProduct, this.selectProduct == "tpc" ? 1 : 2, this.selectProduct);
    },

    // 计算总价
    totalPrice() {
        // 范围系数
        let rangeFactor = this.scopeValue === 0 ? 1 : this.scopeValue === 1 ? 1.5 : 0;
        // 排放源系数
        let emissionFactor = this.emissionSourceValue === 0 ? 1 : this.emissionSourceValue === 1 ? 2 : this.emissionSourceValue === 2 ? 3 : "";
        // 总价 = 9800 × 范围系数 × √公司系数 × 排放源系数 × 购买资格数暂时为1
        if(this.companyValue == '' || this.companyValue == 0 || rangeFactor == "" || emissionFactor == ""){
            this.addTotal = 0;
            this.isPay = false;
        }else if(this.scopeValue == this.productInfo.config.scope &&
            this.companyValue == this.productInfo.config.address_limit &&
            this.emissionSourceValue == this.productInfo.config.source_limit ||
            this.scopeValue < this.productInfo.config.scope ||
            this.companyValue < this.productInfo.config.address_limit ||
            this.emissionSourceValue < this.productInfo.config.source_limit
        ){
            this.$message.error(this.$t('serviceI18n.add_service_cannot_less_than_original_service'));
            this.isPay = false;
            return;
        }else{
            //计算差价：现有套餐总价 - 原有套餐价格
            this.isPay = true;
            this.addTotal = parseFloat(Number(parseFloat(this.basePrice * rangeFactor * Math.sqrt(Number(this.companyValue)) * emissionFactor * 1).toFixed(2)) - Number(this.productInfo.order.amount)).toFixed(2);
        }
    },

    // 选择产品服务
    chooseProduct(value) {
        this.selectProduct = value.code;
        this.selectProductId = value.id;
        console.log("选择产品服务的feature_id", this.selectProductId);
        this.currentRowId = null; // 清空当前选中行的 ID
        this.productInfo = null; // 清空选中的产品信息
        this.tableData = []; // 清空表格数据
        //当前碳足迹不存在购买，隐藏正式套餐介绍
        // if (value.code === 'tzj') {
        //     this.type = 'formal';
        // } else {
        //     this.type = 'formal';
        // }
        this.$nextTick(() => {
            this.loadList();
            this.$refs.serviceTable && this.$refs.serviceTable.doLayout && this.$refs.serviceTable.doLayout();
        });
    },

    //处理套餐状态类型
    getPermissionStatus(row) {
        // 是否有订单,有订单正式服务，无则是体验服务
        const hasOrder = row.order;
        if(hasOrder || row.config.address_limit === 2 || row.config.address_limit === 4 ||
            row.config.address_limit === 30){
            if(row.permission_type === "PAID"){
                return this.$t('serviceI18n.permission_type_list[0].name');
            }else if(row.permission_type === "UPGRADING"){
                return this.$t('serviceI18n.permission_type_list[4].name');
            }else if(row.permission_type === "UPGRADED"){
                return this.$t('serviceI18n.permission_type_list[5].name');
            }else if(row.permission_type === "USING"){
                return this.$t('serviceI18n.permission_type_list[6].name');
            }else if(row.permission_type === "USED"){
                return this.$t('serviceI18n.permission_type_list[7].name');
            }else if(row.permission_type === "EXPIRED"){
                return this.$t('serviceI18n.permission_type_list[8].name');
            }
        }else{
            if(row.permission_type === "PAID"){
                return this.$t('serviceI18n.permission_type_list[0].name');
            }else if (row.permission_type === "TRIAL_PENDING") {
                return this.$t('serviceI18n.permission_type_list[1].name');
            }else if (row.permission_type === "TRIAL_APPROVED") {
                return this.$t('serviceI18n.permission_type_list[2].name');
            }else if (row.permission_type === "TRIAL_REJECTED") {
                return this.$t('serviceI18n.permission_type_list[3].name');
            }else if(row.permission_type === "USING"){
                return this.$t('serviceI18n.permission_type_list[6].name');
            }else if(row.permission_type === "USED"){
                return this.$t('serviceI18n.permission_type_list[7].name');
            }else if(row.permission_type === "EXPIRED"){
                return this.$t('serviceI18n.permission_type_list[8].name');
            }
        }
    },

    // 处理行点击事件
    handleRowClick(row) {
        const hasOrder = row.order;
        if(hasOrder || row.config.address_limit === 2 || row.config.address_limit === 4 ||
            row.config.address_limit === 30){
            if(row.permission_type === "UPGRADING"){
                this.$message.error(this.$t('serviceI18n.current_service_package_upgrading'))
                return
            }else if(row.permission_type === "UPGRADED"){
                this.$message.error(this.$t('serviceI18n.current_service_package_upgraded'))
                return
            }else if(row.permission_type === "USING"){
                this.$message.error(this.$t('serviceI18n.current_service_package_using'))
                return
            }else if(row.permission_type === "USED"){
                this.$message.error(this.$t('serviceI18n.current_service_package_used'))
                return
            }
        }else{
            this.$message.error(this.$t('serviceI18n.trial_service_package_cannot_add'))
            return
        }
        this.currentRowId = row.id; // 更新当前点击的行ID
        this.productInfo = row;
        this.scopeValue = row.config.scope;
        this.companyValue = row.config.address_limit;
        this.emissionSourceValue = row.config.source_limit;
        this.isPay = false;
        this.addTotal = 0;
    },

    // 行样式
    rowStyle({ row }) {
        if (this.currentRowId === row.id) {
            return {
                'background': '#D1ECFD',
                'color': '#000',
                'font-weight': '700'
            }; // 返回选中行的样式
        }
        return {};
    },

    // 检查选项是否被禁用
    isOptionDisabled(optionValue, listType) {
        if (!this.productInfo || !this.productInfo.scope) {
        return false; // 如果没有选中产品信息，则所有选项可用
        }

        if (listType === "scope") {
        // 处理 scopeList 的禁用逻辑
        const scopePriority = {
            "范围一": 1,
            "范围一、二": 2,
            "范围一、二和三": 3
        };

        const currentScopePriority = scopePriority[this.productInfo.scope];
        const optionScopePriority = scopePriority[optionValue];

        // 禁用优先级小于或等于当前 scope 的选项
        return optionScopePriority <= currentScopePriority;
        } else if (listType === "source_limit") {
        // 处理 emissionSourceList 的禁用逻辑
        const emissionSourcePriority = {
            "≤100": 1,
            "101-500": 2,
            "＞500": 3
        };

        const currentEmissionPriority = emissionSourcePriority[this.productInfo.source_limit];
        const optionEmissionPriority = emissionSourcePriority[optionValue];

        // 禁用优先级小于或等于当前 source_limit 的选项
        return optionEmissionPriority <= currentEmissionPriority;
        }

        return false; // 默认不禁用
    },

    //切换套餐类型,正式或体验
    changeType(){
        this.type = this.type == "formal" ? "trial" : "formal";
    },

    //购买
    goPay() {
        this.$refs.chooseProduct.showModal(null, this.selectProduct == "tpc" ? 1 : 2, this.selectProduct);
    },

    //申请试用
    async applyTry() {
        this.applyTryLoading = true;
        const featureId = await this.searchFeatureId();
        trial({
            feature_id: featureId,
        }).then((res) => {
            if(res.data.code == 200){
                this.applyTryLoading = false;
                this.loadList()
                this.$message.success(this.$t('serviceI18n.apply_trial_success'));
            }else{
                this.$message({
                    message: res.data.data,
                    type: 'error'
                })
            }
        }).catch(() => {
            console.error(this.$t('serviceI18n.apply_trial_failed'));
        });
    },
  },
  computed: {
    ...mapState(["userInfo", "orderInfo"]),

    scopeList() {
      return [
        {
          value: 0,
          label: this.$t('serviceI18n.scope_list[0].name')
        },
        {
          value: 1,
          label: this.$t('serviceI18n.scope_list[1].name')
        }
      ];
    },

    // 添加productList计算属性，动态翻译名称
    productList() {
      return this.rawProductList.map(item => ({
        ...item,
        // 根据产品value动态获取翻译文本
        name: this.$t(`orderI18n.feature_title["${item.code}"]`)
      }));
    },
  }
}
</script>
<style>
.highlight {
    color: rgba(24, 161, 246, 1);
    font-weight: bold;
    font-size: 18px;
}
</style>

<style scoped lang="scss">
.back{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    background: rgba(33, 33, 33, 0.5);
    height: 100vh;
    z-index: 999;
}
.serviceView {
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
    background: var(--global-background);
    // width: 1200px;
    width: max-content;
    height: 650px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    z-index: 1001;

    .modalView_pop {
        width: calc(100% - 20px);
        height: calc(100% - 20px);
        background-color: #ffffff; /* 设置不透明的白色底色 */
        background-image: var(--global-inner-background);
        border-radius: 20px;
        display: flex;

        .modalView_pop_l {
            width: 690px;
            height: 100%;
            position: relative;

            .modalView_pop_l_polygon_1{
                position: absolute;
                width: 32px;
                height: 32px;
                top: 0;
                right: -4px
            }

            .modalView_pop_l_polygon_2{
                position: absolute;
                width: 32px;
                height: 32px;
                bottom: 0;
                right: -4px;
            }

            .modalView_pop_l_view {
                width: 645px;
                height: 100%;
                margin: 0 10px 0 35px;
                border-left: 2px dashed #E3E6E8;
                border-right: 2px dashed #E3E6E8;
                .modalView_pop_l_view_t {
                    width: 100%;
                    border-bottom: 2px dashed #E3E6E8;
                    height: 140px;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;


                    .modalView_pop_l_view_t_1 {
                        width: 223px;
                        height: 46px;
                        margin-left: 33px;

                        .modalView_pop_l_view_t_3_text{
                            font-size: 35px;
                            color: rgba(33, 33, 33, 1);
                            font-weight: 500;
                        }
                    }

                    .modalView_pop_l_view_t_2 {
                        font-size: 18px;
                        color: rgba(0, 0, 0, 1);
                        font-weight: 500;
                        margin-left: 35px;
                        letter-spacing: 3px;
                        // margin-top: 10px;
                    }
                }

                .modalView_pop_l_view_b {
                    width: 100%;
                    height: calc(100% - 160px);
                    position: relative;

                    .modalView_pop_l_view_b_2{
                        margin:20px 10px 30px 33px;
                        height: auto;
                        overflow-y: hidden;

                        .modalView_pop_r_2_choose{
                          height: 40px;
                          width: 100%;
                          display: flex;
                          align-items: center;

                            .modalView_pop_r_2_choose_v{
                                height: 100%;
                                display: flex;
                                align-items: center;
                                margin-right: 50px;

                                .modalView_pop_r_2_choose_v_input{
                                    appearance: none; /* 隐藏默认样式 */
                                    width: 25px;
                                    height: 25px;
                                    border: 1px solid #757575;
                                    border-radius: 50%;
                                    margin-right: 10px;
                                    position: relative;
                                    cursor: pointer;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                }

                                .modalView_pop_r_2_choose_v_input:checked {
                                    border-color: #757575;
                                    background-color: #fff;
                                }

                                ::v-deep .modalView_pop_r_2_choose_v_input:checked:after {
                                    content: '';
                                    position: absolute;
                                    top: 50%;
                                    left: 50%;
                                    transform: translate(-50%, -50%);
                                    width: 17px!important; /* 圆点大小 */
                                    height: 17px!important;
                                    border-radius: 50%;
                                    background-color: #757575; /* 圆点颜色 */
                                }

                                span{
                                    font-size: 20px;
                                    font-weight: 700;
                                    color: rgba(0, 0, 0, 1);
                                }
                            }
                        }
                    }

                    .modalView_pop_l_view_b_table{
                        margin: 0 33px auto;
                        overflow-y: auto; /* 启用垂直滚动条 */
                        padding-right: 10px; /* 为滚动条预留空间，避免内容被遮挡 */
                        scrollbar-width: thin; /* 优化滚动条宽度（Firefox） */
                        scrollbar-color: rgba(117, 117, 117, 0.5) transparent;
                        height: calc(100% - 100px)!important;


                        ::v-deep .el-table,
                        ::v-deep .el-table__expanded-cell {
                            background-color: transparent;
                            border-color: rgba(58, 83, 36, 0.75)!important;
                        }

                        ::v-deep .no-wrap-header .cell{
                            word-break: keep-all;
                        }

                        ::v-deep .wrap-header .cell{
                            white-space: normal;
                        }

                        ::v-deep .el-table--border{
                            background-color: transparent!important;
                            border-color: rgba(58, 83, 36, 0.75)!important;
                            border: 1px solid rgba(58, 83, 36, 0.75)!important;
                        }

                        // ::v-deep .el-table__body-wrapper{
                        //     height: 100%!important;
                        //     width: 100%!important;
                        // }

                        /* 表格内背景颜色 */
                        ::v-deep .el-table th,
                        ::v-deep .el-table tr,
                        ::v-deep .el-table td {
                            background-color: transparent;
                            border-color: rgba(58, 83, 36, 0.75)!important;
                        }

                        /* 设置点击行的渐变色背景 */
                        ::v-deep .el-table__body tr.current-row > td {
                            background: linear-gradient(180deg, #DEFFE7 0%, #DBFFF0 50%, #DBFFFF 100%) !important;
                            color: #000 !important; /* 设置文字颜色为黑色 */
                            font-weight: 700 !important;
                        }
                    }

                    .modalView_pop_l_view_b_page{
                        display: flex;
                        align-items: center;
                        justify-content: flex-end;
                        margin-right: 20px;
                    }
                }
            }
        }

        .modalView_pop_r {
            width: 510px;
            height: 100%;

            .modalView_pop_r_1{
                width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;

                .modalView_pop_r_1_t{
                    width: 308px;
                    height: 242px;
                    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                    background: var(--global-primary);
                    border-radius: 10px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: space-around;
                    cursor: pointer;

                    .modalView_pop_r_1_t_img{
                        width: 278px;
                        height: 156px;
                    }

                    .modalView_pop_r_1_t_v{
                        width: 278px;
                        height: 50px;
                        // background: linear-gradient(180deg, rgba(222, 255, 231, 0.5) 0%, rgba(219, 255, 240, 0.5) 50%, rgba(219, 255, 255, 0.5) 100%);
                        background: var(--global-primary);
                        border-radius: 30px;
                        font-size: 20px;
                        color: #fff;
                        font-weight: 500;
                        display: flex;
                        align-items: center;
                        justify-content: center;

                        .modalView_pop_r_1_t_v_img{
                            width: 25px;
                            height: 25px;
                            margin-left: 10px;
                        }
                    }
                }

                .modalView_pop_r_1_b{
                    width: 170px;
                    height: 64px;
                    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                    background: var(--global-primary);
                    border-radius: 10px;
                    margin-top: 60px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    font-size: 24px;
                    color: #fff;
                    font-weight: 500;
                }

                .modalView_pop_r_1_position{
                    position: absolute;
                    right: 16px;
                    bottom: 100px;
                    width: 96px;
                    height: 109px;
                    z-index: 1;
                }

                .modalView_pop_r_1_position_img{
                    position: absolute;
                    right: 33px;
                    bottom: 95px;
                    width: 98px;
                    height: 18px;
                }
            }

            .modalView_pop_r_2{
                // width: 100%;
                height: 100%;
                display: flex;
                flex-direction: column;
                margin-left: 30px;
                margin-right: 30px;

                .modalView_pop_r_2_title{
                    height: 140px;
                    border-bottom: 2px dashed #E3E6E8;
                    margin-bottom: 28px;
                    padding-top: 70px;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .modalView_pop_r_2_title_1{
                        font-size: 18px;
                        // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                        // background: var(--global-primary);
                        background: #56A8C6;
                        -webkit-background-clip: text;
                        background-clip: text;
                        -webkit-text-fill-color: transparent;
                        animation: gradientAnimation 15s ease infinite;
                        cursor: pointer;
                        border-bottom: 1px solid rgba(86, 198, 151, 0.75);
                        letter-spacing: 3px;
                        padding-top: 10px;
                    }

                    @keyframes gradientAnimation {
                        0% {
                            background-position: 0% 50%;
                        }
                        50% {
                            background-position: 100% 50%;
                        }
                        100% {
                            background-position: 0% 50%;
                        }
                    }

                    .active{
                        font-size: 32px;
                        color: rgba(0, 0, 0, 1)!important;
                        font-weight: 700;
                        background: none!important;
                        -webkit-text-fill-color: rgba(0, 0, 0, 1)!important;
                        border-bottom: none;
                        letter-spacing: 0px;
                        padding-top: 0px;
                    }
                }

                .modalView_pop_r_2_info{
                    width: 100%;
                    height: calc(100% - 160px);
                    overflow: hidden; /* 启用垂直滚动条 */

                    .modalView_pop_r_2_info_msView{
                        display: flex;
                        flex-direction: column;
                        color: #052031;

                        .modalView_pop_r_2_info_ms{
                            font-size: 12px;
                            // height: 45px;
                            height: max-content;
                            position: relative;
                            padding-left: 20px;
                            color: #052031;

                            ::v-deep(.highlight) {
                                color: rgba(24, 161, 246, 1);
                                font-weight: bold;
                                font-size: 22px;
                            }

                            .fontSize18{
                                font-size: 14px!important;
                                line-height: 36px!important;
                                font-weight: normal;
                            }
                           

                            .fontSize18:before{
                                content: "•"; /* 圆点字符 */
                                position: absolute;
                                left: -10px;
                                top: 18px;
                                transform: translateY(-50%);
                                color: #18A1F6; /* 圆点颜色 */
                                font-size: 36px; /* 圆点大小 */
                                line-height: 1;
                            }

                            span{
                                font-size: 20px;
                                font-weight: 700;
                                line-height: 45px;
                            }

                            span:before {
                                content: "•"; /* 圆点字符 */
                                position: absolute;
                                left: -10px;
                                top: 21px;
                                transform: translateY(-50%);
                                color: #18A1F6; /* 圆点颜色 */
                                font-size: 36px; /* 圆点大小 */
                                line-height: 1;
                            }
                        }

                        // .modalView_pop_r_2_info_ms:before {
                        //     content: "•"; /* 圆点字符 */
                        //     position: absolute;
                        //     left: -10px;
                        //     top: 21px;
                        //     transform: translateY(-50%);
                        //     color: #333; /* 圆点颜色 */
                        //     font-size: 36px; /* 圆点大小 */
                        //     line-height: 1;
                        // }

                        .pay{
                            width: 300px;
                            height: 45px;
                            border-radius: 16px;
                            // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                            background: var(--global-primary);
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            cursor: pointer;
                            margin: 0 auto;
                            font-size: 22px;
                            font-weight: 700;
                            color: #fff;
                            margin: 43px auto 30px;

                            .pay_inner{
                                width: 300px;
                                height: 45px;
                                background: #F2F2F2;
                                display: flex;
                                border-radius: 18px;
                                align-items: center;
                                justify-content: center;
                                font-size: 22px;
                                color: rgba(117, 117, 117, 1);
                            }
                        }

                        .activePay{
                            // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                            background: var(--global-primary);

                            .pay_inner{
                                background: transparent;
                                color: #fff;
                            }
                        }
                    }

                    .modalView_pop_r_2_info_title{
                        font-size: 24px;
                        font-weight: 700;
                        color: rgba(0, 0, 0, 1);
                    }

                    .modalView_pop_r_2_info_view{
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        height: 66px;
                        font-size: 20px;
                        width: 100%;

                        .modalView_pop_r_2_info_view_1{
                            width: 28%;
                        }

                        .modalView_pop_r_2_info_view_2{
                            width: 36%;
                            text-align: right;
                            font-weight: 700;
                        }

                        ::v-deep .el-select{
                            width: 36%;
                            font-size: 20px;
                            color: rgba(0, 0, 0, 1);
                            font-weight: 700;
                            border: none;
                            outline: none;
                            box-shadow: none;
                            background: transparent!important;
                        }

                        ::v-deep .el-select .el-input__inner{
                            font-size: 20px;
                            color: rgba(0, 0, 0, 1);
                            font-weight: 700;
                            border: none;
                            outline: none;
                            box-shadow: none;
                            background: transparent!important;
                            text-align: right;
                        }

                        .modalView_pop_r_2_info_view_input{
                            width: 36%;
                            text-align: right;
                            font-weight: 700;

                            .modalView_pop_r_2_info_view_input_view{
                                width:70%;
                            }

                            ::v-deep .el-input .el-input__inner{
                                font-size: 20px;
                                color: rgba(0, 0, 0, 1);
                                font-weight: 700;
                                border: 2px solid rgba(58, 83, 36, 1);
                                border-radius: 10px;
                                // background: linear-gradient(180deg, #DEFFE7 0%, #DBFFF0 50%, #DBFFFF 100%)!important;
                                background: var(--global-light-gray)!important;
                                text-align: right;
                            }
                        }
                    }

                    .borderBottom{
                        border-bottom: 1px solid rgba(58, 83, 36, 0.5)
                    }


                }

                .autoY{
                    overflow-y: auto; /* 启用垂直滚动条 */
                    scrollbar-width: thin; /* 优化滚动条宽度（Firefox） */
                    scrollbar-color: rgba(117, 117, 117, 0.5) transparent;
                }

                .modalView_pop_r_2_total{
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    height: 73px;

                    .modalView_pop_r_2_total_l{
                        font-size: 24px;
                        font-weight: 700;
                        color: rgba(0, 0, 0, 1);
                    }

                    .modalView_pop_r_2_total_r{
                        font-family: Impact;
                        font-size: 36px;
                        font-weight: 700;
                        color: rgba(0, 0, 0, 1);
                    }
                }

                .pay{
                    width: 300px;
                    height: 45px;
                    border-radius: 20px;
                    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                    background: var(--global-primary);
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    cursor: pointer;
                    margin: 0 auto;
                    font-size: 22px;
                    font-weight: 700;
                    color: #fff;
                    margin: 43px auto 30px;

                    .pay_inner{
                        width: 300px;
                        height: 45px;
                        background: #F2F2F2;
                        display: flex;
                        border-radius: 18px;
                        align-items: center;
                        justify-content: center;
                        font-size: 22px;
                        color: rgba(117, 117, 117, 1);
                    }
                }

                .activePay{
                    // background: linear-gradient(180deg, #7AE495 0%, #56C697 50%, #339E9E 100%);
                    background: var(--global-primary);

                    .pay_inner{
                        background: transparent;
                        color: #fff;
                    }
                }
            }
        }
    }
}

/* 如果使用scoped，可能需要调整选择器，例如使用深度选择器 >>> */
*[innerHTML*="<br>"] {
    display: inline-block;
    text-indent: 0;
}
*[innerHTML*="<br>"] br + * {
    display: block;
    text-indent: 2em;
}
</style>
